export default "__VITE_ASSET__QYm2mZuG__"